<div class="flex flex-col gap-2">
  @if (label()) {
    <label class="truncate" [ngClass]="smallLabel() ? 'text-sm' : ''" [for]="id()">
      {{ label() | transloco }}
      @if (isRequired()) {
        <span class="text-red" [ngClass]="smallLabel() ? 'text-sm' : ''">*</span>
      }
      @if (tooltipKey()) {
        <app-directus-tooltip class="ml-2" [tooltipKey]="tooltipKey()" />
      }
      <ng-content select="[labelBadge]" />
    </label>
  }

  @if (isReadOnly()) {
    @let selected = selectedOption();
    <input
      pInputText
      [value]="
        isDirectusMode()
          ? (selected?.translations | translateDirectus)
          : (selected?.[optionLabel()] ?? '')
      "
      [disabled]="true"
      class="w-full readOnly"
    />
  } @else {
    <p-select
      [id]="id()"
      [attr.data-testid]="resolvedTestId()"
      [(ngModel)]="value"
      [options]="options()"
      [optionLabel]="isDirectusMode() ? undefined : optionLabel()"
      [optionValue]="optionValue()"
      [placeholder]="placeholder() | transloco"
      [showClear]="clearable()"
      [filter]="filter()"
      [filterBy]="filterField()"
      [disabled]="disabled()"
      [ngClass]="{'p-invalid': showInvalid()}"
      class="w-full"
      appendTo="body"
      (onBlur)="markAsTouched()"
    >
      <ng-template #selectedItem let-selectedOption>
        @if (selectedOption) {
          <div class="flex items-center gap-3">
            <span>
              @if (isDirectusMode()) {
                {{ selectedOption.translations | translateDirectus }}
              } @else {
                {{ selectedOption[optionLabel()] }}
              }
            </span>
          </div>
        }
      </ng-template>

      <ng-template #item let-item>
        <div class="flex items-center justify-between w-full">
          <div class="flex items-center gap-3">
            <span>
              @if (isDirectusMode()) {
                {{ item.translations | translateDirectus }}
              } @else {
                {{ item[optionLabel()] }}
              }
            </span>
          </div>
        </div>
      </ng-template>
    </p-select>
  }
</div>
